import CountdownPage from './CountdownPage';

function App() {
  return <CountdownPage />;
}

export default App;
